import React from 'react';
import { useRelayResource } from '@atlassian/jira-relay-utils';
import { jiraHomePageRightSidePanelResource } from '../services/main';
import { RightSidePanel } from './main';

const RightSidePanelContainer = () => {
	const { queryReference } = useRelayResource(jiraHomePageRightSidePanelResource);

	if (!queryReference) {
		return null;
	}

	return <RightSidePanel queryReference={queryReference} />;
};

export default RightSidePanelContainer;
